<template>
    <div>
        <!-- FASE 4 / BLOCO AC — DOC 16, 17, 44, 45 -->

        <el-row class="u-mt-10 u-mb-15">
            <el-col :xs="24">
                <el-alert type="info" :closable="false" show-icon
                          title="Documentos que esperam a sua aprovação."
                          description="Só aparece aqui a etapa que está liberada agora: as seguintes ficam bloqueadas até a anterior ser decidida.">
                </el-alert>
            </el-col>
        </el-row>

        <div class="container-table" v-loading="!statusList">
            <table class="table table-striped">
                <thead>
                    <tr><th>Documento</th><th class="hidden-mobile">Fluxo</th>
                        <th>Etapa</th><th class="hidden-mobile">O que fazer</th>
                        <th class="u-text-center" style="width:190px">Ação</th></tr>
                </thead>
                <tbody>
                    <tr v-for="p in items" :key="p.id">
                        <td>
                            <router-link :to="'/admin/documento/detalhe/'+p.documento_id">{{ p.documento }}</router-link>
                        </td>
                        <td class="hidden-mobile meta">{{ p.fluxo }}</td>
                        <td>{{ p.nome }} <el-tag size="mini">etapa {{ p.ordem }}</el-tag></td>
                        <td class="hidden-mobile meta">{{ p.descricao_atividade || '—' }}</td>
                        <td class="u-text-center acao">
                            <el-button type="success" icon="el-icon-check" size="mini"
                                       @click="decidir(p, true)">APROVAR</el-button>
                            <el-button class="u-ml-10" type="danger" icon="el-icon-close" size="mini"
                                       @click="abrirReprovar(p)">REPROVAR</el-button>
                        </td>
                    </tr>
                    <tr v-if="!items.length && statusList">
                        <td colspan="5" class="u-text-center u-mt-25">Nada aguardando sua aprovação.</td>
                    </tr>
                </tbody>
            </table>

            <el-row v-if="statusList">
                <el-col :xs="24" :sm="12">
                    <div class="u-text-left u-mt-10">
                        Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros.
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" v-if="paginate.qtdItens > 30">
                    <div class="u-text-right">
                        <el-pagination :current-page="paginate.page" class="u-mt-10" :total="paginate.qtdItens"
                                       @current-change="p => { paginate.page = p; carregar() }"
                                       :page-size="30" background layout="prev, pager, next" small></el-pagination>
                    </div>
                </el-col>
            </el-row>
        </div>

        <!-- DOC 17 — parecer obrigatório na reprovação -->
        <el-dialog title="Reprovar documento" :visible.sync="dialogReprovar" width="520px">
            <el-form label-position="top">
                <el-form-item label="Parecer (obrigatório)">
                    <el-input v-model="parecer" type="textarea" :rows="4" maxlength="2000"
                              placeholder="Explique o motivo da reprovação."></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="dialogReprovar = false">Cancelar</el-button>
                <el-button class="u-ml-10" type="danger" @click="confirmarReprovacao">REPROVAR</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>

export default {
    data: () => ({
        statusList: false,
        items: [],
        paginate: { page: 1, qtdItens: 0, from: '', to: '' },
        dialogReprovar: false,
        alvo: null,
        parecer: ''
    }),
    mounted () { this.carregar() },
    methods: {
        base () { return this.$store.state.config.baseUrlApi },
        auth () { return this.$store.getters.getHeaderAuth },

        erro (e) {
            window.eventBus.$emit('loading', false)
            const d = e && e.response ? e.response.data : null
            let msg = 'Não foi possível concluir a operação.'
            if (d && typeof d.erro === 'string') msg = d.erro
            window.eventBus.$emit('alert', { msg: msg, type: 'error' })
            this.$store.commit('throwException', e)
        },

        carregar () {
            this.statusList = false
            this.$axios.post(`${this.base()}/api/documento-fluxo/pendencias?page=${this.paginate.page}`,
                {}, this.auth()).then(r => {
                this.items = r.data.data
                this.paginate.qtdItens = r.data.total
                this.paginate.from = r.data.from
                this.paginate.to = r.data.to
                this.statusList = true
            }).catch(e => { this.statusList = true; this.erro(e) })
        },

        decidir (p, aprovar, parecer) {
            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.base()}/api/documento-fluxo/decidir/${p.id}`,
                { aprovar: aprovar, parecer: parecer || null }, this.auth()).then(r => {
                window.eventBus.$emit('loading', false)

                const situacao = r.data.execucao.situacao
                let msg = aprovar ? 'Etapa aprovada.' : 'Documento reprovado.'
                if (situacao === 'aprovado') msg = 'Documento aprovado — era a última etapa.'

                window.eventBus.$emit('alert', { msg: 'Sucesso! - ' + msg, type: 'success' })
                this.dialogReprovar = false
                this.parecer = ''
                this.carregar()
            }).catch(e => { this.erro(e) })
        },

        abrirReprovar (p) { this.alvo = p; this.parecer = ''; this.dialogReprovar = true },

        confirmarReprovacao () {
            if (!this.parecer || !this.parecer.trim()) {
                window.eventBus.$emit('alert', { msg: 'Descreva o parecer da reprovação.', type: 'warning' })
                return
            }
            this.decidir(this.alvo, false, this.parecer)
        }
    }
}
</script>
<style scoped>
.meta { font-size: 12px; color: #909399; }
</style>
